import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import DropdownMenu from './DropdownMenu';
import { ArrowRoundedDown7x5Svg } from '../../svg';

class Dropdown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
        };
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleOutsideClick);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleOutsideClick);
    }

    setWrapperRef = (node) => {
        this.wrapperRef = node;
    };

    handleOutsideClick = (event) => {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState(() => ({
                open: false,
            }));
        }
    };

    handleButtonClick = () => {
        this.setState((state) => ({
            open: !state.open,
        }));
    };

    handleItemClick = (item) => {
        const { onClick } = this.props;

        this.setState(() => ({
            open: false,
        }));

        if (onClick) {
            onClick(item);
        }
    };

    render() {
        const { open } = this.state;
        const { title, withIcons, items } = this.props;

        const classes = classNames('topbar-dropdown', {
            'topbar-dropdown--opened': open,
        });

        return (
            <div className={classes} ref={this.setWrapperRef}>
                <button aria-label="navigation" name="navigation button" className="topbar-dropdown__btn" type="button" onClick={this.handleButtonClick}>
                    {title}
                    <ArrowRoundedDown7x5Svg />
                </button>

                <div className="topbar-dropdown__body">
                    <DropdownMenu
                        layout="topbar"
                        withIcons={withIcons}
                        items={items}
                        onClick={this.handleItemClick}
                    />
                </div>
            </div>
        );
    }
}

Dropdown.propTypes = {
    title: PropTypes.node.isRequired,
    items: PropTypes.array.isRequired,
    withIcons: PropTypes.bool,
    onClick: PropTypes.func,
};

Dropdown.defaultProps = {
    withIcons: false,
    onClick: undefined,
};

export default Dropdown;
